import { Injectable } from '@angular/core';
import {
  IEstacionMeteorologica,
  ICreateEstacionMeteorologica,
  IQueryParam,
  IUpdateEstacionMeteorologica,
  IComando,
  IAlerta,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { apiBase } from 'src/environments/environment';
import { HelperService } from '../../../auxiliares/helper.service';
import { HttpService } from '../../../auxiliares/http.service';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class EstacionMeteorologicasService {
  constructor(private http: HttpService) {}

  // EstacionMeteorologicas
  public getEstacionMeteorologica(
    id: string
  ): Observable<IEstacionMeteorologica> {
    return this.http.get(`${api}/estacionmeteorologicas/${id}`);
  }
  public getEstacionMeteorologicas(queryParams?: IQueryParam): Observable<{
    data: IEstacionMeteorologica[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/estacionmeteorologicas`, { params });
  }
  public createEstacionMeteorologica(
    data: ICreateEstacionMeteorologica
  ): Observable<IEstacionMeteorologica> {
    return this.http.post(`${api}/estacionmeteorologicas`, data);
  }
  public updateEstacionMeteorologica(
    id: string,
    data: IUpdateEstacionMeteorologica
  ): Observable<IEstacionMeteorologica> {
    return this.http.put(`${api}/estacionmeteorologicas/${id}`, data);
  }
  public deleteEstacionMeteorologica(
    id: string
  ): Observable<IEstacionMeteorologica> {
    return this.http.delete(`${api}/estacionmeteorologicas/${id}`);
  }

  // Reportes

  public async exportarReportes(
    queryParams?: IQueryParam,
    filename = 'reportes.xlsx'
  ): Promise<void> {
    let params = HelperService.getQueryParams(queryParams);
    await this.http.getFile(
      `${api}/reportes/exportar/estacion-meteorologica`,
      filename,
      params
    );
  }

  // Comandos

  public solicitarUbicacion(
    deveui: string
  ): Observable<IEstacionMeteorologica> {
    return this.http.post(`${api}/comandos/estacion-meteorologica/ubicacion`, {
      deveui,
    });
  }

  public delComando(id: string): Observable<IComando> {
    return this.http.delete(`${api}/comandos/${id}`);
  }

  // Alertas

  public delAlerta(id: string): Observable<IAlerta> {
    return this.http.delete(`${api}/alertas/${id}`);
  }

  // Parseos

  public estadoEstacion(dato: IEstacionMeteorologica) {
    const limite = this.fechaHaceXHoras(6);
    const ultimaComunicacion = dato.ultimaComunicacion
      ? new Date(dato.ultimaComunicacion)
      : null;

    if (!ultimaComunicacion || limite > ultimaComunicacion) {
      return 'Sin reportar';
    }

    return dato.ultimoEstado;
  }

  public devolverLluvia(lluvia: number) {
    return lluvia;
  }

  public devolverDuracionLluvia(duracionMinutos: number) {
    const dias = Math.floor(duracionMinutos / 1440);
    const horas = Math.floor((duracionMinutos - dias * 1440) / 60);
    const minutos = duracionMinutos - dias * 1440 - horas * 60;

    const textoDias = dias > 0 ? `${dias}d ` : '';
    const textoHoras = horas > 0 ? `${horas}h ` : '';

    return `${textoDias} ${textoHoras} ${minutos}m`;
  }

  private fechaHaceXHoras(horas: number) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    return fecha;
  }

  public direccionViento(direccion: number = 0): string {
    if (direccion >= 0 && direccion < 22.5) {
      return 'Norte';
    }
    if (direccion >= 22.5 && direccion < 67.5) {
      return 'Noreste';
    }
    if (direccion >= 67.5 && direccion < 112.5) {
      return 'Este';
    }
    if (direccion >= 112.5 && direccion < 157.5) {
      return 'Sureste';
    }
    if (direccion >= 157.5 && direccion < 202.5) {
      return 'Sur';
    }
    if (direccion >= 202.5 && direccion < 247.5) {
      return 'Suroeste';
    }
    if (direccion >= 247.5 && direccion < 292.5) {
      return 'Oeste';
    }
    if (direccion >= 292.5 && direccion < 337.5) {
      return 'Noroeste';
    }
    if (direccion >= 337.5 && direccion < 360) {
      return 'Norte';
    }
    return 'Desconocido';
  }
}
